module.exports = __webpack_public_path__ + "img/img35.94b421ff.jpg";